export default __webpack_public_path__ + "static/media/205.74e656c5.jpg";